
import Vue from 'vue';

export default Vue.extend({
  props: {
    isButtonCta: {
      type: Boolean,
      default: false,
    },
    isPrimaryTheme: {
      type: Boolean,
      default: true,
    },
    calloutCopy: {
      type: String,
      default: '',
    },
    ctaCopy: {
      type: String,
      default: '',
    },
    ctaUrl: {
      type: String,
      default: '/',
    },
    ctaTracking: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    onCtaClick() {
      this.$emit('on-cta-click');
    },
    // Bind @click.native to <router-link> tag will not work, hence changing to manual router change.
    onCtaLinkClick(): void {
      (this.ctaTracking as Function)();
      this.$router.push({ path: this.ctaUrl });
      this.$emit('on-cta-link-click');
    },
  },
})
